import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { CategoryId } from '#server/models';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Convert a display title to a URL-safe slug. */
export function toSlug(title: string): string {
  return title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

/** Toggle a plain numeric ID in/out of an array. */
export function toggleId(ids: number[], id: number): number[] {
  return ids.includes(id) ? ids.filter((i) => i !== id) : [...ids, id];
}

/** Toggle a CategoryId (composite key) in/out of an array. */
export function toggleCategoryId(ids: CategoryId[], catId: CategoryId): CategoryId[] {
  const exists = ids.some((c) => c.id === catId.id && c.groupId === catId.groupId);
  return exists
    ? ids.filter((c) => !(c.id === catId.id && c.groupId === catId.groupId))
    : [...ids, catId];
}

export function calculateDistanceMultiplier(width: number) {
  const defaultWidth = 1920;
  const widthRatio = width / defaultWidth;
  const distanceMultiplier = 0.8 + 0.2 * (widthRatio < 1 ? 1 / widthRatio : 1);
  return distanceMultiplier;
}

export function getCurrentRouteParts() {
  const pathname = window.location.pathname;
  const urlParams = new URLSearchParams(window.location.search);
  const parts = pathname.split('/').filter((part) => part);
  return {
    areaSlug: parts[1],
    viewerType: parts[2],
    subjectSlug: parts[3],
    labelSlug: urlParams.get('selectedLabel')
  };
}

export function getCommonAnalyticsContext() {
  const { areaSlug, viewerType, subjectSlug, labelSlug } = getCurrentRouteParts();
  return {
    context1: areaSlug ?? undefined,
    context2: viewerType ?? undefined,
    context3: subjectSlug ?? undefined,
    context4: labelSlug ?? undefined
  };
}
